<app-post-list [isNewsFeed]="'false'" [isSinglePost]="true" [id]="id"></app-post-list>
